module.exports = __webpack_public_path__ + "img/贾向敬.3dd4bd77.jpg";